import React from "react";
import { NavLink } from "react-router-dom";
import { Col, Row, Button } from "react-bootstrap";

const BottomBtns = ({ mockData, setMockData }) => {
  const showSaveAndExit =
    !mockData.dashboardFlag &&
    !mockData.saveProcess &&
    !mockData.resultId &&
    mockData.currentQuestion > 0 &&
    mockData.questionData.length !== mockData.currentQuestion + 1;

  const showSubmitBtn =
    !mockData.dashboardFlag &&
    !mockData.submitProcess &&
    mockData.secondCount !== 0 &&
    !mockData.resultId &&
    !(mockData.questionData.length !== mockData.currentQuestion + 1);

  const showNextBtn =
    !mockData.dashboardFlag &&
    mockData.secondCount !== 0 &&
    !mockData.resultId &&
    mockData.questionData.length !== mockData.currentQuestion + 1 &&
    mockData.questionData.length !== 0;

  const nextButton = (e, p) => {
    console.log("nextButton clicked with param:", p);
    if (!mockData.soundStat) {
      setMockData((prevState) => {
        return { ...prevState, soundModal: true };
      });
    } else {
      let pending = 0;
      let msg = "";
      let complete = 0;
      if (p === 0) {
        pending = 0;
        msg = "Do you want to go to next Question?";
      } else if (p === 1) {
        pending = 0;
        msg = "Do you want to submit test?";
        complete = 1;
        // clearInterval(mockData.intervalId)
      } else if (p === 2) {
        msg = "Do you want to save this question and exit mock test?";
        pending = 1;
        // clearInterval(mockData.intervalId)
      }
      setMockData((prevState) => {
        return {
          ...prevState,
          modal: true,
          pending: pending,
          msg: msg,
          nextType: p,
          complete: complete,
          stopRecording: false, // Reset stopRecording when opening modal
        };
      });
    }
  };

  return (
    <Col xs={12}>
      <div className="bottomBtns fixed-bottom-row mock-header-gap">
        <Row className="align-items-center mx-0 gap-1 fixed-bottom-row w-100 mock-header-gap">
          <Col xs="auto" className="d-flex justify-content-center align-items-center py-1 mock-bottom-btn-toggle" style={{ minWidth: "15%",minHeight: "50px" }}>
            {showSaveAndExit && (
              <Button
                color="primary"
                onClick={(e) => nextButton(e, 2)}
                size="xs"
                disabled={mockData.currentQuestion === 0}
                className={`mock-btn bottomBtnFont d-flex align-items-center ${mockData.currentQuestion === 0 ? 'disable_btn' : 'mock-bottom-btn'}`}
              >
                Save & Exit
              </Button>
            )}
            {mockData.saveProcess &&
              !(
                mockData.questionData.length !==
                mockData.currentQuestion + 1
              ) && (
                <Button color="primary" size="xs" className="mock-btn bottomBtnFont d-flex align-items-center">
                  Wait...
                </Button>
              )}
            {showSubmitBtn && (
              <Button
                color="primary"
                onClick={(e) => nextButton(e, 1)}
                size="xs"
                className="mock-btn bottomBtnFont d-flex align-items-center"
              >
                Submit
              </Button>
            )}
            {mockData.submitProcess &&
              !(
                mockData.questionData.length !==
                mockData.currentQuestion + 1
              ) && (
                <Button color="primary" size="xs" className="mock-btn bottomBtnFont d-flex align-items-center">
                  Wait...
                </Button>
              )}

            {mockData.submitProcess &&
              !(
                mockData.questionData.length !==
                mockData.currentQuestion + 1
              ) && (
                <Button color="primary" size="xs" className="mock-btn bottomBtnFont d-flex align-items-center">
                  Wait...
                </Button>
              )}
            {mockData.resultId && (
              <NavLink to={"/admin/result/" + mockData.resultId}>
                <Button color="primary" size="xs" className="mock-btn bottomBtnFont d-flex align-items-center">
                  Show Result
                </Button>
              </NavLink>
            )}
            {mockData.dashboardFlag && (
              <NavLink to={"/admin/dashboard"} className="text-decoration-none">
                <Button color="primary" size="xs" className="mock-btn bottomBtnFont d-flex align-items-center">
                  Go to Dashboard
                </Button>
              </NavLink>
            )}
            {/* {mockData.timeOutFlag && <div>Test stopped due to timeout</div>} */}
          </Col>
          <Col className="text-center py-2 z-3 mock-bottom-btn-toggle flex-grow-1" style={{ minHeight: "50px" }}></Col>
          <Col xs="auto" className="d-flex justify-content-center align-items-center py-1 mock-bottom-btn-toggle" style={{ minWidth: "15%",minHeight: "50px" }}>
            {showNextBtn && (
              <Button
                color="primary"
                onClick={(e) => nextButton(e, 0)}
                size="xs"
                className="mock-btn bottomBtnFont d-flex align-items-center"
              >
                NEXT
              </Button>
            )}
          </Col>
        </Row>
      </div>
    </Col>
  );
};

export default BottomBtns;
